import LottieAnimation from "lottie-web-vue";

export default {
  install(app) {
    app.use(LottieAnimation);
  },
};
